import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import BulkBroadcastsAPI from '../../api/bulkBroadcasts';

export const state = {
  records: [],
  currentBroadcast: null,
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getBroadcasts(_state) {
    return _state.records;
  },
  getCurrentBroadcast(_state) {
    return _state.currentBroadcast;
  },
};

export const actions = {
  get: async function getBroadcasts({ commit }) {
    commit(types.SET_BULK_BROADCAST_UI_FLAG, { isFetching: true });
    try {
      const response = await BulkBroadcastsAPI.get();
      commit(types.SET_BULK_BROADCASTS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_BULK_BROADCAST_UI_FLAG, { isFetching: false });
    }
  },

  show: async function showBroadcast({ commit }, id) {
    commit(types.SET_BULK_BROADCAST_UI_FLAG, { isFetchingItem: true });
    try {
      const response = await BulkBroadcastsAPI.show(id);
      commit(types.SET_CURRENT_BULK_BROADCAST, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_BULK_BROADCAST_UI_FLAG, { isFetchingItem: false });
    }
  },

  create: async function createBroadcast({ commit }, broadcastObj) {
    commit(types.SET_BULK_BROADCAST_UI_FLAG, { isCreating: true });
    try {
      const response = await BulkBroadcastsAPI.create(broadcastObj);
      commit(types.ADD_BULK_BROADCAST, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_BULK_BROADCAST_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...data }) => {
    commit(types.SET_BULK_BROADCAST_UI_FLAG, { isUpdating: true });
    try {
      const response = await BulkBroadcastsAPI.update(id, data);
      commit(types.EDIT_BULK_BROADCAST, response.data);
      commit(types.SET_CURRENT_BULK_BROADCAST, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_BULK_BROADCAST_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_BULK_BROADCAST_UI_FLAG, { isDeleting: true });
    try {
      await BulkBroadcastsAPI.delete(id);
      commit(types.DELETE_BULK_BROADCAST, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_BULK_BROADCAST_UI_FLAG, { isDeleting: false });
    }
  },

  pause: async ({ commit }, id) => {
    try {
      const response = await BulkBroadcastsAPI.pause(id);
      commit(types.EDIT_BULK_BROADCAST, response.data);
      commit(types.SET_CURRENT_BULK_BROADCAST, response.data);
    } catch (error) {
      throw new Error(error);
    }
  },

  resume: async ({ commit }, id) => {
    try {
      const response = await BulkBroadcastsAPI.resume(id);
      commit(types.EDIT_BULK_BROADCAST, response.data);
      commit(types.SET_CURRENT_BULK_BROADCAST, response.data);
    } catch (error) {
      throw new Error(error);
    }
  },

  previewSplit: async (_, params) => {
    const response = await BulkBroadcastsAPI.previewSplit(params);
    return response.data;
  },
};

export const mutations = {
  [types.SET_BULK_BROADCAST_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_CURRENT_BULK_BROADCAST](_state, data) {
    _state.currentBroadcast = data;
  },

  [types.ADD_BULK_BROADCAST]: MutationHelpers.create,
  [types.SET_BULK_BROADCASTS]: MutationHelpers.set,
  [types.EDIT_BULK_BROADCAST]: MutationHelpers.update,
  [types.DELETE_BULK_BROADCAST]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
